import { PaidDomainsApiClient } from '@fourthwall/services/dist/PaidDomainsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGetPaidDomainsQuery = createQueryHook(PaidDomainsApiClient.getPaidDomains, {
  queryKey: ['getPaidDomains'],
})
